export { strings, loadLanguage } from './localization';
